/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Text, useTheme, VFlow } from 'bold-ui'
import { format } from 'date-fns'
import React, { useCallback } from 'react'

import { HistoricoCabecalhoModel } from '../../../model/historicoModel'
import HistoricoAccordion from '../../accordion/HistoricoAccordion'

interface HistoricoAtendimentoTableItemProps {
  historico: HistoricoCabecalhoModel
  dataNascimentoCidadao: LocalDate
  cpfOuCnsCidadao: string
}

export default function HistoricoAtendimentoTableItem(props: HistoricoAtendimentoTableItemProps) {
  const { historico, dataNascimentoCidadao, cpfOuCnsCidadao } = props
  const theme = useTheme()

  const createDateContent = useCallback(() => {
    const [day, month, year] = format(historico.dataAtendimento, 'dd/MM/yyyy').split('/')
    return (
      <VFlow vSpacing={0}>
        <Text fontSize={1} fontWeight='bold'>
          {`${day}/${month}`}
        </Text>
        <Text fontSize={0.975} fontWeight='bold'>
          {year}
        </Text>
      </VFlow>
    )
  }, [historico.dataAtendimento])

  return (
    <React.Fragment>
      <Cell
        size={1}
        style={css`
          color: ${theme.pallete.gray.c20};
          text-align: center;
        `}
      >
        {historico.dataAtendimento && createDateContent()}
      </Cell>
      <Cell size={11}>
        <HistoricoAccordion
          historico={historico}
          dataNascimentoCidadao={dataNascimentoCidadao}
          cpfOuCnsCidadao={cpfOuCnsCidadao}
        />
      </Cell>
    </React.Fragment>
  )
}
